import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { clearErrors } from "../../redux/layout/layoutActions";

export default function ErrorAlert() {
  const dispatch = useDispatch();
  const errors = useSelector((state) => state.layout.errors);

  useEffect(() => {
    if (errors.length > 0) {
      setTimeout(() => {
        dispatch(clearErrors());
      }, 6000);
    }
  }, [errors, dispatch]);

  return errors.length ? (
    <div className="w-screen bg-red-600 flex justify-center items-center absolute top-20 flex-col z-50">
      {errors &&
        [...new Set(errors)].map((error, idx) => (
          <Alert key={idx} variant="destructive" className="w-full m-1 bg-red-600 border-red-600">
            <AlertDescription className="text-white text-center text-lg p-4">
              {error}
            </AlertDescription>
          </Alert>
        ))}
    </div>
  ) : null;
}
